export enum MethodIntentionEnum {
  PayForPicup = 1,
  CourierRequest = 2,
}
